module.exports = __webpack_public_path__ + "static/kamilah-williams-kemp.c46489d2.webp";